<div
  class="tw-group tw-flex tw-items-center tw-justify-between tw-pr-3 tw-bg-gray-800 tw-bg-opacity-30 tw-border tw-border-solid tw-border-gray-700 tw-border-opacity-50 tw-rounded-xl tw-transition-colors tw-duration-200 hover:tw-bg-gray-800 hover:tw-bg-opacity-50 hover:tw-border-teal-600 hover:tw-border-opacity-60">
  <button
    (click)="selectItem()"
    class="tw-flex-1 tw-h-full focus:tw-outline-none focus:tw-rounded-l-xl tw-py-3 tw-pl-3"
    aria-label="Select this list">
    <div class="tw-flex tw-items-center tw-gap-2">
      <div class="tw-text-white tw-font-medium tw-mb-1 tw-flex">{{ item?.name || 'Unnamed List' }}</div>
      <mat-icon
        class="tw-text-lg tw-leading-5 tw-font-bold tw-text-teal-500 tw-opacity-0 group-hover:tw-opacity-80 tw-transition-opacity tw-duration-200">
        arrow_forward
      </mat-icon>
    </div>

    <div *ngIf="showCreator && item?.createdBy" class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-400 tw-pl-2">
      <mat-icon class="tw-text-gray-400 tw-h-5 tw-w-5 tw-text-[18px]">
        person_outline
      </mat-icon>
      <span class="tw-text-sm tw-text-gray-400">{{ item.createdBy }}</span>
    </div>

    <div class="tw-mt-1">
      <button
        (click)="toggleExpansion($event)"
        class="tw-bg-transparent tw-border-none tw-p-0 tw-text-left tw-w-full tw-flex tw-items-center tw-gap-2 tw-pl-2 tw-cursor-pointer"
        aria-label="Toggle list expansion">
        <span
          class="tw-text-sm tw-text-gray-400 tw-flex tw-items-center tw-gap-1.5 hover:tw-text-gray-300 tw-transition-colors">
          <mat-icon *ngIf="!isExpanded" class="tw-text-base">business</mat-icon>
          <span>{{ item?.items?.length || 0 }} companies</span>
          <span *ngIf="item?.createdAt" class="tw-text-xs tw-text-gray-500">
            {{ item.createdAt | date:'MMM d, y' }}
          </span>
          <mat-icon
            class="tw-text-base tw-transition-transform tw-ml-1"
            [class.tw-rotate-180]="isExpanded">
            expand_more
          </mat-icon>
        </span>
      </button>
      <div *ngIf="isExpanded" class="tw-mt-2 tw-space-y-2 fade-in">
        <div
          *ngFor="let company of item?.items"
          class="tw-text-sm tw-text-gray-400 tw-pl-6 tw-flex tw-items-center tw-gap-2">
          <mat-icon class="tw-text-base tw-text-gray-500">business</mat-icon>
          <span class="tw-text-left">{{ getCompanyName(company.id) }}</span>
        </div>
      </div>
    </div>
  </button>
  
  <div *ngIf="allowDelete" class="tw-flex tw-items-center">
    <button
      (click)="deleteItem($event)"
      class="tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 focus:tw-opacity-100"
      aria-label="Delete this list">
      <div
        class="tw-w-8 tw-h-8 tw-rounded-full tw-text-red-400 tw-transition-colors tw-bg-gray-700 hover:tw-bg-gray-600 tw-flex tw-items-center tw-justify-center">
        <mat-icon class="tw-text-lg tw-font-semibold tw-mb-1">delete_outline</mat-icon>
      </div>
    </button>
  </div>
</div>